<template>
  <v-container id="regular-tables-view" tag="section">
    <material-card icon="mdi-clipboard-text" icon-small color="accent">
      <h3 class="font-weight-bold mx-4 my-4">Тодорxойлолтууд</h3>
      <TodorhoiloltTable
        :item="{ name: 'Тодорxойлолт', fbpath: 'xtodorhoilolt' }"
      ></TodorhoiloltTable>
    </material-card>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("@/firebaseConfig.js");
export default {
  data: () => ({}),
  components: {
    TodorhoiloltTable: () => import("./TodorhoiloltTable"),
  },
  props: {},
};
</script>
